module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "setting__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.Title)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.selected),
      expression: "item.selected"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.item, "selected", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.ddTitle)))]), _vm._v(" "), _vm._l((_vm.item.items), function(options, index) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(options.name))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f160380","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/input.dropdown.vue
// module id = 236
// module chunks = 0